<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_TODO_CLSF')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-code-select
            ref="todoClassificationCode"
            :selected="frame0.selectedCode.COD_CLSF"
            :pageId="pageId"
            codeId="COD_TODO_CLSF"
            :initialSelectedIndex="0"
            @list-clicked="detailListSetting"
            @loaded="codeSelectLoaded"
          />
          <div class="comp_spacing" />
          <sui-custom-select
            ref="todoDetailClassificationCode"
            :selected="frame0.selectedCode.COD_DCLSF"
            :optionList="optionList.COD_DCLSF"
            :initialSelectedIndex="0"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_TODO_NM')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            ref="nodeTodoName"
            v-model="frame0.nodeTodoName"
            maxlength="100"
          />
          <sui-button
            type="button"
            class="comm_btn_InputScr"
            @click="onClickSrch('nodeTodoName')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_DDLN_DT')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-radio
            v-model="frame0.deadlineDTYn"
            value="Y"
          >
            Yes
          </sui-radio>
          <sui-radio
            v-model="frame0.deadlineDTYn"
            value="N"
          >
            No
          </sui-radio>
          <div class="comp_spacing" />
          <div
            class="comm_label ds_flex"
            style="width:35px;"
          >
            D +
          </div>
          <sui-text-field
            ref="deadlineDTValue"
            v-model="frame0.deadlineDTValue"
            maxlength="100"
            mask="number"
            style="width:50px;"
          />
        </div>     
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_PAGE_ID')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <!-- <sui-text-field
            ref="pageId"
            v-model="frame0.pageId"
            maxlength="100"
          /> -->
          <div class="comm_label">
            {{ frame0.pageId }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_PRMT_SET')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            ref="todoProcessParamValue"
            v-model="frame0.todoProcessParamValue"
            :noIcon="true"
            maxlength="1000"
          />
          <sui-button
            type="button"
            class="comm_btn_InputScr"
            @click="onClickSrch('todoProcessParamValue')"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_TODO_CPLT_TYPE')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-radio
            v-model="frame0.todoCompletionTypeCode"
            value="AL"
          >
            All
          </sui-radio>
          <sui-radio
            v-model="frame0.todoCompletionTypeCode"
            value="AN"
          >
            Any
          </sui-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_TODO_PSTNG')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-code-select
            ref="todoPostingCode"
            :selected="frame0.selectedCode.COD_TODO_PSTNG"
            :pageId="pageId"
            codeId="COD_TODO_PSTNG"
            :initialSelectedIndex="0"
          />
        </div>
        <div class="col-xs-1" />
        <div class="col-xs-5" />      
      </div>
    </div>
    <div class="mrB30" />
    <sui-grid
      ref="grid"
      :columns="gridColumns0"
      :dataset="'dsNodeTodoDetail'"
      :showDisplayCountControl="false"
      :showMoveControl="true"
      :multiselect="true"
    >
      <div class="comp_spacing" />
      <div class="btn_wrapL">
        <sui-button
          type="button"
          class="comm_btn_gridTop"
          @click="onClickRowAdd"
        >
          {{ $t('MSG_BTN_ROW_ADD') }}
        </sui-button>
        <sui-button
          v-permission:delete="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="onClickRowDelete"
        >
          {{ $t('MSG_BTN_ROW_DEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_gridTop"
          @click="onClickRowCancel"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
      </div>
    </sui-grid>
    <div class="comm_btn_wrap">
      <!-- <sui-button
        type="button"
        class="comm_btn_border"
      >
        미리보기
      </sui-button> -->
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00004_T03', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    nodeId: {
      type: String,
      default: null,
    },
    nodeTodoUid: {
      type: String,
      default: null,
    },
    paramValue: {
      type: Object,
      default: null,
    },
    selectedRowData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      mountedFlag: true,
      detailOptionComplete: false,
      optionList: {
        COD_DCLSF: [{ key: '', label: '' }],
        COD_TODO_DTL_CLSF: [],
        COD_NODE_TODO_DTL_FMT: [],
        CM: [],
        CL: [],
      },
      COD_CLSF: { key: '', label: '' },
      frame0: {
        selectedCode: {
          COD_CLSF: { key: '', label: '' },
          COD_DCLSF: { key: '', label: '' },
          COD_TODO_PSTNG: { key: '', label: '' },
        },
        nodeTodoUid: '',
        nodeTodoName: '',
        deadlineDTYn: '',
        deadlineDTValue: '',
        pageId: '',
        todoCompletionTypeCode: '',
        todoProcessParamValue: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_MSG_RESO'),
        datafield: 'nodeTodoDetailTitleMultiLanguageId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
            {
              trim: true,
              maxlength: 100,
            },
            this.dsNodeTodoDetail, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_DTL_TIT'),
        datafield: 'nodeTodoDetailTitle',
      }, {
        text: this.$t('MSG_TXT_DTL_CNTN'),
        datafield: 'nodeTodoDetailContent',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextFieldWithButton(row, column, value, htmlElement, {
            textFieldProps: {
              readonly: false,
              disabled: false,
            },
            buttonProps: {
              disabled: false,
              style: 'comm_btn_InputScr',
            },
            handler: this.onClickParamAdd,
            maxlength: 500,
          }, this.dsNodeTodoDetail, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_FMT_TYPE'),
        datafield: 'nodeToDoDetailFormatCode',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
            optionList: this.optionList.COD_NODE_TODO_DTL_FMT,
          }, this.dsNodeTodoDetail, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'userName',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
          }, this.dsNodeTodoDetail, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '150px',
      }],
    };
  },
  computed: {},
  watch: {
    nodeId() {
      if (!utils.isEmpty(this.nodeId)) {
        this.setNodeTodoData();
        this.setNodeTodoDetailData();
      }
    },
    paramValue: {
      deep: true,
      handler() {
        this.setParamValue();
      },
    },
  },
  activated() {
    // 탭 활성화 시 data 재 호출(기본정보 변경 시 바로 반영)
    // detailOption 항목이 load 되어져 있는 경우에만 실행 (최초 mounted의 경우 실행x)
    // mounted의 경우 selectBox @loaded 이벤트로 data load.
    if (!utils.isEmpty(this.nodeId) && this.detailOptionComplete) {
      this.setNodeTodoData();
      this.setNodeTodoDetailData();
    }
  },
  mounted() {
    this.loadCodeList().then(() => {
      this.setDetailOptions();
    }).catch(() => {});
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 저장되지 않은 데이터 확인
     */
    makeSnapshot() {
      const snapshotData = utils.assign({},
        this.frame0,
        {
          todoClassificationCode: this.frame0.selectedCode.COD_CLSF.key,
          todoDetailClassificationCode: this.frame0.selectedCode.COD_DCLSF.key,
          todoPostingCode: this.frame0.selectedCode.COD_TODO_PSTNG.key,
        });

      return snapshotData;
    },
    /**
     * 할일 분류 optionList 조회
     * */
    loadCodeList() {
      return http.mergeCodeList(this.pageId, ['COD_TODO_DTL_CLSF', 'COD_NODE_TODO_DTL_FMT'], this.optionList);
    },
    setDetailOptions() {
      utils.forEach(this.optionList.COD_TODO_DTL_CLSF, value => {
        if (utils.startsWith(value.key, 'CM')) {
          this.optionList.CM.push(value);
        } else {
          this.optionList.CL.push(value);
        }
      });

      this.detailOptionComplete = true;
    },
    detailListSetting() {
      // this.frame0.selectedCode.COD_DCLSF.key = '';
      this.optionList.COD_DCLSF = this.optionList[this.frame0.selectedCode.COD_CLSF.key];
      if (utils.size(this.optionList[this.frame0.selectedCode.COD_CLSF.key]) > 0) {
        this.frame0.selectedCode.COD_DCLSF.key = this.optionList[this.frame0.selectedCode.COD_CLSF.key][0].key;
      } else {
        this.frame0.selectedCode.COD_DCLSF.key = '';
      }
      // this.$refs.todoDetailClassificationCode.reset();
      if (this.mountedFlag) {
        setTimeout(() => {
          this.saveSnapshot(this.makeSnapshot());
        }, 500);
        this.mountedFlag = false;
      }
    },
    codeSelectLoaded() {
      // SELECTBOX 목록 조회 후 데이터 SET
      if (!utils.isEmpty(this.nodeId)) {
        this.setNodeTodoData();
        this.setNodeTodoDetailData();
      } else {
        this.detailListSetting();
      }
    },
    /**
     * 할일 기본 정보 SET
     * */
    setNodeTodoData() {
      const queryParams = {
        nodeId: this.nodeId,
      };

      http.request(this.pageId, 'DTS_CMR_00024', {
        query: queryParams,
      }).then(res => {
        if (res.data.length < 1) {
          this.setNodeTodoDataReset();
        } else {
          utils.forEach(this.frame0, (value, key) => {
            if (utils.isEqual(key, 'selectedCode')) {
              this.frame0[key].COD_CLSF.key = res.data[0].todoClassificationCode;
              this.detailListSetting();
              this.frame0[key].COD_DCLSF.key = res.data[0].todoDetailClassificationCode;
              this.frame0[key].COD_TODO_PSTNG.key = res.data[0].todoPostingCode;
            } else if (utils.isEqual(key, 'deadlineDTValue')) {
              this.frame0[key] = res.data[0][key].toString();
            } else {
              this.frame0[key] = res.data[0][key] || '';
            }
          });
          this.saveSnapshot(this.makeSnapshot());
          this.$emit('propDataEdit', 'nodeTodoUid', this.frame0.nodeTodoUid);
        }
      });
    },
    /**
     * 할일 정보 목록 SET
     * */
    setNodeTodoDetailData() {
      const queryParams = {
        nodeId: this.nodeId,
      };

      http.request(this.pageId, 'DTS_CMR_00026', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, ['finalModificationDTM']);
        this.dsNodeTodoDetail.submit();
        this.dsNodeTodoDetail.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * 할일 정보 목록 RESET
     * */
    setNodeTodoDataReset() {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectedCode')) {
          this.frame0.selectedCode.COD_CLSF.key = utils.clone(this.$refs.todoClassificationCode.optionList[0].key);
          this.detailListSetting();
        } else if (utils.isEqual(key, 'pageId')) {
          const pageId = utils.isEmpty(this.selectedRowData.pageId) ? '' : this.selectedRowData.pageId;
          this.frame0[key] = pageId;
        } else {
          this.frame0[key] = '';
        }
      });
      this.dsNodeTodoDetail.submit();
      this.dsNodeTodoDetail.setRawData([]);
    },
    /**
     * 저장
     * */
    onClickSave() {
      const dataParams = {
        nodeId: this.nodeId,
        nodeTodoUid: this.frame0.nodeTodoUid,
        todoClassificationCode: this.frame0.selectedCode.COD_CLSF.key,
        todoDetailClassificationCode: this.frame0.selectedCode.COD_DCLSF.key,
        todoPostingCode: this.frame0.selectedCode.COD_TODO_PSTNG.key,
        nodeTodoName: this.frame0.nodeTodoName,
        deadlineDTYn: this.frame0.deadlineDTYn,
        deadlineDTValue: this.frame0.deadlineDTValue,
        pageId: this.frame0.pageId,
        todoCompletionTypeCode: this.frame0.todoCompletionTypeCode,
        todoProcessParamValue: this.frame0.todoProcessParamValue,
      };

      utils.assign(dataParams, this.rowState());

      if (!this.selectedNodeCheck()) return false;
      if (!this.validationCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00025', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.dsNodeTodoDetail.submit();
          this.setNodeTodoData();
          this.setNodeTodoDetailData();
        });
      });

      return true;
    },
    rowState() {
      const insertTodoDetailList = [];
      const updateTodoDetailList = [];
      const deleteTodoDetailList = [];

      // 그리드 순서에 따른 정렬순서 설정
      utils.forEach(this.dsNodeTodoDetail.data, (value, key) => {
        this.dsNodeTodoDetail.setData(key, 'nodeTodoDetailOrder', key + 1);
      });

      utils.forEach(this.dsNodeTodoDetail.rowStateMap, (key, value) => {
        let index = -1;
        switch (key) {
          case 'D':
            index = utils.findIndex(this.dsNodeTodoDetail.originalData, o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) deleteTodoDetailList.push(this.dsNodeTodoDetail.originalData[index]);
            break;
          case 'U':
            index = utils.findIndex(this.dsNodeTodoDetail.data, o => utils.isEqual(o['dataset-row-id'], value));
            // this.dsNodeTodoDetail.data[index].nodeTodoDetailOrder = index + 1;
            if (index > -1) updateTodoDetailList.push(this.dsNodeTodoDetail.data[index]);
            break;
          case 'C':
            index = utils.findIndex(this.dsNodeTodoDetail.data, o => utils.isEqual(o['dataset-row-id'], value));
            // this.dsNodeTodoDetail.data[index].nodeTodoDetailOrder = index + 1;
            if (index > -1) insertTodoDetailList.push(this.dsNodeTodoDetail.data[index]);
            break;
          default:
            break;
        }
      });

      return {
        insertTodoDetailList,
        updateTodoDetailList,
        deleteTodoDetailList,
      };
    },
    validationCheck() {
      let flag = true;

      if (utils.isEmpty(utils.trim(this.frame0.selectedCode.COD_CLSF.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_TODO_CLSF')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.selectedCode.COD_DCLSF.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_TODO_CLSF')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.nodeTodoName))) {
        // 할일명을 입력해주세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_TODO_NM')),
          null,
          () => {
            this.$refs.nodeTodoName.setFocus();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.deadlineDTYn))) {
        // 마감일을 선택해주세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DDLN_DT')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.deadlineDTValue))
      && utils.isEqual(utils.trim(this.frame0.deadlineDTYn), 'Y')) {
        // 마감일 값 입력해주세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_DDLN_DT_VAL')),
          null,
          () => {
            this.$refs.deadlineDTValue.setFocus();
          });
        return false;
      }
      // if (utils.isEmpty(utils.trim(this.frame0.pageId))) {
      //   // 페이지 ID 입력해주세요
      //   utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PAGE_ID')),
      //     null,
      //     () => {
      //       this.$refs.pageId.setFocus();
      //     });
      //   return false;
      // }
      if (utils.isEmpty(utils.trim(this.frame0.todoCompletionTypeCode))) {
        // 할일완료유형을 선택해주세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_TODO_CPLT_TYPE')));
        return false;
      }
      if (utils.isEqual(this.frame0.todoCompletionTypeCode, 'Y')
      && utils.isEmpty(utils.trim(this.frame0.todoProcessParamValue))) {
        // 할일파라미터값 입력해주세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PRMT_SET')),
          null,
          () => {
            this.$refs.todoProcessParamValue.setFocus();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.selectedCode.COD_TODO_PSTNG.key))) {
        // 할일 게시를 선택해주세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_TODO_PSTNG')));
        return false;
      }
      utils.forEach(this.dsNodeTodoDetail.data, (obj, row) => {
        if (utils.isEmpty(obj.nodeTodoDetailTitleMultiLanguageId)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_MSG_RESO')),
          null,
          () => {
            this.gridSetFocus(row, 'nodeTodoDetailTitleMultiLanguageId');
          });
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.nodeTodoDetailContent)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_PRMT_ID')),
          null,
          () => {
            this.gridSetFocus(row, 'nodeTodoDetailContent');
          });
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.nodeToDoDetailFormatCode)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_FMT_TYPE')),
          null,
          () => {
            this.gridSetFocus(row, 'nodeToDoDetailFormatCode');
          });
          flag = false;
          return false;
        }
        return null;
      });
      return flag;
    },
    gridSetFocus(rowIndex, datafield) {
      this.$refs.grid.$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs.grid.getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
    /**
     * grid button Event
     * */
    onClickRowAdd() {
      const defaultRow = [{
        nodeTodoDetailTitleMultiLanguageId: '',
        nodeTodoDetailContent: '',
      }];
      this.dsNodeTodoDetail.addRows(defaultRow);
    },
    onClickRowDelete() {
      const selectedIndexes = this.dsNodeTodoDetail.getSelectedIndexes();
      this.dsNodeTodoDetail.deleteRows(selectedIndexes);
    },
    onClickRowCancel() {
      this.dsNodeTodoDetail.submit();
      this.dsNodeTodoDetail.setRawData(this.dsNodeTodoDetail.originalData);
    },
    /**
     * grid 파라미터ID BUTTON EVENT
     * 파라미터 관리 팝업 호출
     * */
    onClickParamAdd(event, dataRow) {
      if (!this.selectedNodeCheck()) return false;
      this.$emit('paramPopupCall', 'grid', dataRow['dataset-row-id']);
      return null;
    },
    /**
     * 파라미터 설정 파라미터 BUTTON EVENT
     * 파라미터 관리 팝업 호출
     * */
    onClickSrch(type) {
      if (!this.selectedNodeCheck()) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_ID'), this.$t('MSG_TXT_NODE')));
      } else {
        this.$emit('paramPopupCall', type);
      }
    },
    /**
     * 파라미터 관리 팝업 callBack
     * */
    setParamValue() {
      if (utils.isEqual(this.paramValue.type, 'grid')) {
        const index = utils.findIndex(this.dsNodeTodoDetail.data,
          o => utils.isEqual(o['dataset-row-id'], this.paramValue.index));
        const value = this.dsNodeTodoDetail.data[index].nodeTodoDetailContent + this.paramValue.value;

        this.dsNodeTodoDetail.setData(index, 'nodeTodoDetailContent', value);
      } else if (utils.isEqual(this.paramValue.type, 'todoProcessParamValue')) {
        this.frame0.todoProcessParamValue += this.paramValue.value;
      } else if (utils.isEqual(this.paramValue.type, 'nodeTodoName')) {
        this.frame0.nodeTodoName += this.paramValue.value;
      }
    },

    selectedNodeCheck() {
      if (utils.isEmpty(utils.trim(this.nodeId))) {
        utils.messageBox('warning', this.$t('MSG_ALT_NODE_NOT_INFO'));
        return false;
      }
      return true;
    },
  },
  datasets: [{
    id: 'dsNodeTodoDetail',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'nodeTodoDetailUid', map: 'nodeTodoDetailUid' },
      { type: 'string', name: 'nodeTodoUid', map: 'nodeTodoUid' },
      { type: 'string', name: 'nodeTodoDetailTitleMultiLanguageId', map: 'nodeTodoDetailTitleMultiLanguageId' },
      { type: 'string', name: 'nodeTodoDetailTitle', map: 'nodeTodoDetailTitle' },
      { type: 'string', name: 'nodeTodoDetailContent', map: 'nodeTodoDetailContent' },
      { type: 'string', name: 'nodeTodoDetailOrder', map: 'nodeTodoDetailOrder' },
      { type: 'string', name: 'nodeToDoDetailFormatCode', map: 'nodeToDoDetailFormatCode' },
      { type: 'string', name: 'loginId', map: 'loginId' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'departmentName', map: 'departmentName' },
      { type: 'string', name: 'departmentEnglishName', map: 'departmentEnglishName' },
      { type: 'string', name: 'displayLanguageId', map: 'displayLanguageId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
    ],
  }],
};
</script>
<style scoped>
</style>
